import React from 'react';
import PropTypes from 'prop-types';

import style from './Select.module.css';

const Select = React.memo(
  ({ options, onChange, value, styles = {}, firstOption }) => {
    return (
      <select
        onChange={onChange}
        value={value}
        style={styles}
        className={style.select}
      >
        {firstOption && (
          <option disabled key="initial" value="">
            {firstOption}
          </option>
        )}
        {options.map(item => {
          return (
            <option key={item.id} value={item.value}>
              {item.text}
            </option>
          );
        })}
      </select>
    );
  },
);

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  styles: PropTypes.shape({}),
};

export default Select;
